export default __webpack_public_path__ + "maps-examples-view-annotation-marker-960-c6cc320ff607e3a6205d98509b0ae78e.png";